import React, { useState, useEffect, useMemo } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import styled, { css, withTheme } from "styled-components";

const StyledDropdown = styled(Dropdown)`
  .dropdown-toggle {
    background: ${(props) => props.theme?.whiteSmoke} !important;
    box-shadow: 0px 3px 6px #0000001a !important;
    border-radius: 7px;
    border: 0 !important;
    color: black !important;
    font-weight: 600;
    font-size: 16px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    min-width: ${(props) => `${props.width || 0}px`};
    padding: 8px 15px;

    &::after {
      ${(props) =>
        props.disabled &&
        css`
          display: none;
        `}
    }
  }

  &.show > .dropdown-toggle {
    background-color: white;
    color: black;
  }

  &.show > .btn-primary.dropdown-toggle:focus {
    box-shadow: 0px 3px 6px #0000001a;
  }

  .btn-primary:not(:disabled):not(.disabled):active,
  .btn-primary:not(:disabled):not(.disabled).active,
  .show > .btn-primary.dropdown-toggle {
    background-color: white;
    color: black;
  }

  .dropdown-menu {
    box-shadow: 0px 3px 6px #0000004d;
    border-radius: 7px;
    border: 0;
    color: black;
    font-weight: 600;
    font-size: 16px;
    min-width: ${(props) => `${props.width || 0}px`};
    max-height: ${(props) => (props.limitheight ? "250px" : "none")};
    overflow-y: ${(props) => (props.limitheight ? "scroll" : "visible")};
    .dropdown-item {
      color: black;
      font-weight: 600;
      font-size: 16px;
      padding: 5px 15px;
    }
  }
`;

const StyledDropdownItem = styled(Dropdown.Item)`
  background-color: ${(props) =>
    props.$isSelected ? "#9a84964a" : "transparent"};
`;

const CustomDropdown = (props) => {
  const {
    placeholder,
    onChange,
    width,
    disabled,
    limitheight,
    tabindexprop,
    align,
    options,
    value,
    defaultValue,
  } = props;

  const onChangeCallback = (item) => {
    if (onChange) {
      onChange(item);
    }
  };

  const getLimitHeight = useMemo(() => {
    if (limitheight) {
      return typeof limitheight === "number" ? !!limitheight : +limitheight;
    }
    return limitheight;
  }, [limitheight]);

  const isItemSelected = (item) => {
    let isSelected = false;
    isSelected = item.value === value;

    return isSelected;
  };

  return (
    <StyledDropdown
      {...props}
      data-testid={props["data-testid"] || "custom-dropdown"}
      width={width}
      limitheight={getLimitHeight}
      disabled={disabled}
      align={align}
    >
      <Dropdown.Toggle
        disabled={disabled}
        tabIndex={tabindexprop}
        id="custom-dropdown"
        data-testid={
          props["custom-dropdown-button-data-testid"] ||
          "custom-dropdown-button"
        }
      >
        <span
          data-testid="custom-dropdown-selected-value"
          className="custom-dropdown-selected-value"
        >
          {value ?? defaultValue ?? placeholder ?? ""}
        </span>
      </Dropdown.Toggle>

      {options && options.length > 0 && (
        <Dropdown.Menu
          data-testid={
            props["custom-dropdown-menu-data-testid"] || "custom-dropdown-menu"
          }
        >
          {options?.map((item) => (
            <StyledDropdownItem
              key={`key_${item.id ?? item}`}
              onClick={() => onChangeCallback(item)}
              data-testid={`item-${item.id ?? item}`}
              $isSelected={isItemSelected(item)}
            >
              {item.value}
            </StyledDropdownItem>
          ))}
        </Dropdown.Menu>
      )}
    </StyledDropdown>
  );
};

export default withTheme(CustomDropdown);
